import styled from 'styled-components';
import media from '../../../styles/theme/breakpoints';

export const AppWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const HeaderWrapper = styled.header`
  background: ${({ theme }) => theme.colors.neutral[0]};
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.sticky};
  box-shadow: ${({ theme }) => theme.elevation.sm};
`;

export const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: ${({ theme, $maxWidth }) => $maxWidth || theme.layout.maxWidth};
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing[6]};

  ${media.laptop} {
    padding: ${({ theme }) => theme.spacing[4]};
  }

  ${media.mobile} {
    padding: ${({ theme }) => theme.spacing[3]};
  }
`;

export const FooterWrapper = styled.footer`
  background: ${({ theme }) => theme.colors.primary[500]};
  color: ${({ theme }) => theme.colors.neutral[0]};
  padding: ${({ theme }) => theme.spacing[6]};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ theme }) => theme.layout.footerMinHeight};
`;

export const PageTitle = styled.h1`
  font-size: ${({ theme }) => theme.typography.fontSize['2xl']};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.neutral[900]};
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`;

export const SectionTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.neutral[800]};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;
